import { useMutation } from '@tanstack/react-query';
import * as Api from '../api';

// Joins a team via link token or short code (authenticated user). Used by the
// public join landing page. Errors are surfaced by the caller so it can render
// the org-full / invalid states inline.
const useJoinByToken = () => {
  return useMutation({
    mutationFn: async (token: string) => {
      const response = await Api.joinByToken(token);
      return response.data.data;
    },
  });
};

export default useJoinByToken;
